import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CmpSci = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4 6.65c.1-.7.7-1.2 1.4-1.2h2.5c.7 0 1.3.5 1.4 1.2l.2 1.4 1.1-.8c.6-.5 1.4-.4 1.9.1l1.8 1.8c.5.5.5 1.3.1 1.8l-1 1.1 1.4.2c.7.1 1.2.7 1.2 1.4v2.4c0 .7-.5 1.3-1.2 1.4l-1.4.2.8 1.1c.5.6.4 1.4-.1 1.9l-1.8 1.8c-.5.5-1.3.5-1.8.1l-1.1-.8-.2 1.4c-.1.7-.7 1.2-1.4 1.2h-2.5c-.7 0-1.3-.5-1.4-1.2l-.2-1.4-1.1.8c-.6.5-1.4.4-1.9-.1l-1.8-1.8c-.5-.5-.5-1.3-.1-1.8l.8-1.1-1.4-.2c-.7-.1-1.2-.7-1.2-1.4v-2.5c0-.7.5-1.3 1.2-1.4l1.4-.2-.8-1.1c-.5-.6-.4-1.4.1-1.9l1.8-1.8c.5-.5 1.3-.5 1.8-.1l1.1.8.4-1.3Zm1.7.6-.2 1.6c-.1.5-.4.9-.9 1.1h-.1c-.5.2-1 .1-1.4-.2l-1.2-1-1.3 1.4 1 1.2c.3.4.4.9.2 1.4v.1c-.2.5-.6.8-1.1.9l-1.5.2v1.8l1.6.2c.5.1.9.4 1.1.9v.1c.2.5.1 1-.2 1.4l-1 1.2 1.2 1.2 1.2-1c.4-.3.9-.4 1.4-.2h.1c.5.2.8.6.8 1.1l.2 1.5h1.8l.2-1.6c.1-.5.4-.9.9-1.1h.1c.5-.2 1-.1 1.4.2l1.2 1 1.2-1.2-1-1.2c-.3-.4-.4-.9-.2-1.4v-.1c.2-.5.6-.8 1.1-.9l1.5-.2v-1.8l-1.2-.1c-.5-.1-.9-.4-1.1-.9v-.1c-.2-.5-.1-1 .2-1.4l1-1.2-1.2-1.2-1.2 1c-.4.3-.9.4-1.4.2h-.1c-.5-.2-.8-.6-.8-1.1l-.2-1.5h-2.1v-.3Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 13.05c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8Zm-3.6 1.8c0-2 1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6-1.6 3.6-3.6 3.6-3.6-1.6-3.6-3.6Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1 2.05H.9c-.5 0-.9.4-.9.9v29.6c0 .5.4.9.9.9h14.4v6.7h-4.9c-.5 0-.9.4-.9.9s.4.9.9.9h23.2c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-4.9v-6.7h14.4c.5 0 .9-.4.9-.9V2.95c0-.5-.4-.9-.9-.9Zm-16.2 38.2h-9.8v-6.7h9.8v6.7Zm15.3-8.6H1.8v-4h40.3v4h.1Zm0-5.9H1.8V3.85h40.3v21.9h.1Z"
  }));
});
CmpSci.displayName = 'CmpSci';
CmpSci.defaultProps = {
  'aria-label': 'CmpSci'
};
export default CmpSci;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/CmpSci.js
// module id = 2995
// module chunks = 11